import AllProductsSection from "../components/AllProductsSection";

function AllProducts() {
  return <AllProductsSection />;
}

export default AllProducts;
